import { render, staticRenderFns } from "./RecuperarSenha.vue?vue&type=template&id=382b0d5a&scoped=true&"
import script from "./RecuperarSenha.vue?vue&type=script&lang=js&"
export * from "./RecuperarSenha.vue?vue&type=script&lang=js&"
import style0 from "./recuperar_senha.scss?vue&type=style&index=0&id=382b0d5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "382b0d5a",
  null
  
)

export default component.exports